// Source/Analytics/Tracking.ts
function addItem(args) {
  const { isOffer, code, payload } = args;
  const detail = {
    ...payload,
    isOffer,
    code: code ?? null
  };
  const event = new CustomEvent("Add-Item", { detail });
  window.dispatchEvent(event);
}
var API = {
  addItem
};
window.Tracking = API;

// Source/Analytics/Cart.ts
async function fetchCart() {
  if (window.ymq_option)
    return window.ymq_option.cart;
  return await fetch("/cart.js").then((response) => response.json()).then((data) => data);
}

// Source/Bullshit/Cart.ts
var Default_Root = "https://api.steda.de/";
function cartEndpoint() {
  const root = window.Steda?.Routes?.Root || Default_Root;
  return new URL("api/v1/cart", root).href;
}
async function fetchCustom(codes) {
  const payload = { codes };
  const body = JSON.stringify(payload);
  const response = await fetch(cartEndpoint(), {
    method: "POST",
    body,
    headers: {
      "Accept-Language": Shopify.locale,
      "Content-Type": "application/json"
    }
  });
  if (!response.ok)
    return null;
  const data = await response.json();
  return codes.map((code) => ({
    ...data[code],
    code
  }));
}

// Source/Analytics/Purchase-Offer.ts
var Key_Code = "_steda_code";
var Key_Code_Legacy = "Konfigurationscode";
var getCode = (item) => item.properties[Key_Code] ?? item.properties[Key_Code_Legacy];
window.addEventListener("Purchase-Offer", async (event) => {
  const cart = await fetchCart();
  const contactForm = document.querySelector(`#cartContactForm`);
  const discountApplications = cart.cart_level_discount_applications.map(toCheckoutDiscountApplication(cart));
  const codes = cart.items.map(getCode).filter((code) => !!code);
  console.debug("Purchase-Offer::Codes", codes);
  const overrides = await fetchCustom(codes);
  const getOverride = (item) => {
    const code = getCode(item);
    if (!code)
      return null;
    const override = overrides.find((override2) => override2.code === code);
    if (!override)
      return null;
    return override;
  };
  console.debug("Purchase-Offer::Overrides", overrides);
  const items = cart.items.map(toCheckoutLine(cart, getOverride));
  let subtotal = 0;
  for (const item of cart.items) {
    const price = getOverride(item)?.price ?? item.final_price * 0.01;
    subtotal += price * item.quantity;
  }
  const total = subtotal + (cart.total_price - cart.items_subtotal_price);
  try {
    Shopify.analytics.publish("lead", {
      content_type: "product",
      currency: cart.currency,
      value: total,
      contents: cart.items.map((item) => {
        const price = getOverride(item)?.price ?? item.final_price * 0.01;
        return {
          item_price: price,
          quantity: item.quantity,
          id: item.sku || String(item.product_id)
        };
      })
    });
  } catch (exception) {
    console.debug("Tracking: lead", exception);
  }
  Shopify.analytics.publish("Purchase-Offer", {
    checkout: {
      transactions: undefined,
      delivery: undefined,
      shipping: undefined,
      token: undefined,
      discountApplications,
      lineItems: items,
      currency: cart.currency,
      email: contactForm.querySelector(`#email`).value,
      phone: contactForm.querySelector(`#phone`).value,
      shippingAddress: {
        provinceCode: undefined,
        countryCode: contactForm.querySelector(`#country`).value,
        firstName: contactForm.querySelector(`#firstName`).value,
        lastName: contactForm.querySelector(`#lastName`).value,
        address1: contactForm.querySelector(`#address`).value,
        address2: undefined,
        province: undefined,
        country: undefined,
        city: contactForm.querySelector(`#city`).value,
        zip: contactForm.querySelector(`#zip`).value
      },
      subtotal: {
        currencyCode: cart.currency,
        amount: subtotal
      },
      totalPrice: {
        currencyCode: cart.currency,
        amount: total
      },
      totalTax: {
        currencyCode: cart.currency,
        amount: total - total * (1 / 1.19)
      },
      order: {
        id: undefined
      }
    }
  });
});
function toCheckoutLine(cart, getOverride) {
  return (item) => {
    const sellingPlanAllocation = toCheckoutSellingAllocation(item);
    const discountAllocations = item.line_level_discount_allocations.map(toCheckoutLineDiscountAllocation(cart));
    const properties = toCheckoutProperties(item.properties);
    const variant = toCheckoutVariant(cart)(item);
    const price = getOverride(item)?.price ?? item.final_price * 0.01;
    return {
      sellingPlanAllocation,
      discountAllocations,
      properties,
      variant,
      quantity: item.quantity,
      title: item.title,
      id: item.key,
      finalLinePrice: {
        currencyCode: cart.currency,
        amount: price * item.quantity
      }
    };
  };
}
function toCheckoutSellingAllocation(item) {
  const plan = item.selling_plan_allocation?.selling_plan;
  if (!plan)
    return null;
  return {
    sellingPlan: {
      name: plan.name,
      id: String(plan.id)
    }
  };
}
function toCheckoutLineDiscountAllocation(cart) {
  return (allocation) => {
    const application = allocation.discount_application;
    const discountApplication = toCheckoutDiscountApplication(cart)(application);
    return {
      discountApplication,
      amount: {
        currencyCode: cart.currency,
        amount: allocation.amount * 0.01
      }
    };
  };
}
function toCheckoutDiscountApplication(cart) {
  return (application) => {
    const isFixed = application.value_type === "fixed_amount";
    const value = isFixed ? {
      currencyCode: cart.currency,
      amount: application.value
    } : {
      amount: Number(application.value)
    };
    return {
      allocationMethod: application.allocation_method.toUpperCase(),
      targetSelection: application.target_selection.toUpperCase(),
      targetType: application.target_type.toUpperCase(),
      title: application.title,
      type: application.type.toUpperCase(),
      value
    };
  };
}
function toCheckoutProperties(properties) {
  return Object.entries(properties).map(([key, value]) => ({ key, value }));
}
function toCheckoutVariant(cart) {
  return (item) => {
    const src = item.featured_image.url;
    return {
      untranslatedTitle: item.variant_title,
      image: src ? { src } : null,
      title: item.variant_title,
      sku: item.sku === "" ? null : item.sku,
      id: String(item.id),
      price: {
        currencyCode: cart.currency,
        amount: item.price * 0.01
      },
      product: {
        untranslatedTitle: item.product_title,
        vendor: item.vendor,
        title: item.product_title,
        type: item.product_type === "" ? null : item.product_type,
        url: item.url,
        id: String(item.product_id)
      }
    };
  };
}

// Source/Analytics/Add-Item.ts
window.addEventListener("Add-Item", async (event) => {
  const {
    id: variantId,
    isOffer,
    handle,
    quantity,
    code
  } = event.detail;
  console.debug("Analytics::Add-Item", { variantId, handle, quantity, isOffer, code });
  const override = await fetchOverride(code);
  const product = await fetchProduct(handle);
  console.debug(`GTM Product`, { handle }, JSON.stringify(product, null, 4), JSON.stringify(override, null, 4));
  const variant = product.variants.find((variant2) => variant2.id === variantId);
  let price = variant.price * 0.01;
  if (override)
    price = override.price;
  const src = product.featured_image;
  const payload = {
    cartLine: {
      quantity,
      merchandise: {
        untranslatedTitle: variant.public_title,
        image: src ? { src } : null,
        title: variant.public_title,
        sku: variant.sku === "" ? null : variant.sku,
        id: String(variant.id),
        product: {
          untranslatedTitle: product.title,
          vendor: product.vendor,
          title: product.title,
          type: product.type === "" ? null : product.type,
          url: new URL(`/products/${handle}`, window.location.href).href,
          id: String(product.id)
        },
        price: {
          currencyCode: "EUR",
          amount: price
        }
      },
      cost: {
        totalAmount: {
          currencyCode: "EUR",
          amount: price * quantity
        }
      }
    }
  };
  const type = isOffer ? "Add-Offer" : "Add-To-Cart";
  Shopify.analytics.publish(type, payload);
  console.debug("Analytics::AddItem::Publish", {
    type,
    payload
  });
});
async function fetchProduct(handle) {
  const path = `/products/${handle}.js`;
  const base = window.location.href;
  const url = new URL(path, base);
  const response = await fetch(url);
  const data = await response.json();
  return data;
}
async function fetchOverride(code) {
  if (!code)
    return null;
  const data = await fetchCustom([code]);
  return data[0];
}
